import { render } from "./AgencyCard.vue?vue&type=template&id=60865582"
import script from "./AgencyCard.vue?vue&type=script&lang=js"
export * from "./AgencyCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__